import actions from "./actions";
import {setErrorReducer, setRequestReducer, setSuccessReducer} from "../helper";

let formDesign;
const initState = {
    formDesignCreateState: false, // create.js
    formDesignCreateResult: {},

    formDesignReadState: false, // view.js

    formDesignReadAllState: false, // index.js
    formDesigns: [],
    pagination: {},

    formDesignUpdateState: false, // view.js
    formDesignUpdateResult: {},

    formDesignDeleteState: false,

    formDesign: {},

    formDesignPreviewState: false,
    formDesignPreview: {
        head: null,
        body: null,
    },
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.FORM_DESIGN_CREATE_REQUEST:
            return setRequestReducer(state, 'formDesignCreateState');
        case actions.FORM_DESIGN_CREATE_SUCCESS:
            return setSuccessReducer(state, 'formDesignCreateState', {
                formDesignCreateResult: action.formDesign,
            });
        case actions.FORM_DESIGN_CREATE_ERROR:
            return setErrorReducer(state, 'formDesignCreateState');

        case actions.FORM_DESIGN_READ_ALL_REQUEST:
            return setRequestReducer(state, 'formDesignReadAllState');
        case actions.FORM_DESIGN_READ_ALL_SUCCESS:
            return setSuccessReducer(state, 'formDesignReadAllState', {
                formDesigns: action.formDesigns,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });
        case actions.FORM_DESIGN_READ_ALL_ERROR:
            return setErrorReducer(state, 'formDesignReadAllState');

        case actions.FORM_DESIGN_READ_REQUEST:
            return setRequestReducer(state, 'formDesignReadState');
        case actions.FORM_DESIGN_READ_SUCCESS:
            return setSuccessReducer(state, 'formDesignReadState', {
                formDesign: action.formDesign,
            });
        case actions.FORM_DESIGN_READ_ERROR:
            return setErrorReducer(state, 'formDesignReadState');

        case actions.FORM_DESIGN_UPDATE_REQUEST:
            return setRequestReducer(state, 'formDesignUpdateState');
        case actions.FORM_DESIGN_UPDATE_SUCCESS:
            return setSuccessReducer(state, 'formDesignUpdateState');
        case actions.FORM_DESIGN_UPDATE_ERROR:
            return setErrorReducer(state, 'formDesignUpdateState');

        case actions.FORM_DESIGN_DELETE_REQUEST:
            return setRequestReducer(state, 'formDesignDeleteState');
        case actions.FORM_DESIGN_DELETE_SUCCESS:
            return setSuccessReducer(state, 'formDesignDeleteState');
        case actions.FORM_DESIGN_DELETE_ERROR:
            return setErrorReducer(state, 'formDesignDeleteState');

        case actions.FORM_DESIGN_PREVIEW_REQUEST:
            return setRequestReducer(state, 'formDesignPreviewState');
        case actions.FORM_DESIGN_PREVIEW_SUCCESS:
            return setSuccessReducer(state, 'formDesignPreviewState', {
                formDesignPreview: action.formDesignPreview,
            });
        case actions.FORM_DESIGN_PREVIEW_ERROR:
            return setErrorReducer(state, 'formDesignPreviewState');

        case actions.FORM_DESIGN_CHANGE: // Partial update
            formDesign = {
                ...(action.reset ? initState.formDesign : state.formDesign),
                ...action.request,
            };

            return {
                ...state,
                formDesign,
            };

        case actions.FORM_DESIGN_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
